<template>
    <form-view class="case-create-view" @submitsuccess="handleSubmit">
        <veui-steps
            :steps="store.stepsInfo.data"
            :current="store.stepsInfo.current"
            v-if="store.stepsInfo.data.length"/>
        <template slot="field">
            <veui-field
                name="title"
                field="title"
                label="标题:"
                :rules="[
                    {
                        name: 'required',
                        value: true,
                        triggers: 'blur,input'
                    },
                    {
                        name: 'pattern',
                        value: '^[0-9a-zA-Z\u4E00-\u9FA5]+$',
                        triggers: 'blur,input',
                        message: '请输入数字,字母或汉字'
                    },
                    {
                        name: 'maxLength',
                        value: 30,
                        triggers: 'blur,input'
                    }
                ]"
                :readonly="isEdit"
                tip="标题创建后不可更改，请谨慎填写">
                <veui-input v-model="store.formData.title" placeholder="30个字符以内"/>
            </veui-field>
            <veui-field
                label="描述:"
                name="description"
                :rules="[
                    {
                        name: 'required',
                        value: true,
                        triggers: 'blur,input'
                    },
                    {
                        name: 'maxLength',
                        value: 300,
                        triggers: 'blur,input'
                    }
                ]"
                field="description">
                <veui-textarea v-model="store.formData.description" placeholder="最多300个字符"/>
            </veui-field>
            <veui-field
                :key="index"
                :name="item.name"
                :field="item.name"
                :label="item.title"
                :tip="item.description"
                v-for="(item, index) in store.spec"
                :rules="item.required ? 'required' : ''">
                <veui-uploader
                    name="file"
                    :max-count="1"
                    max-size="10mb"
                    :action="uploadUrl"
                    request-mode="iframe"
                    :accept="item.accept"
                    v-model="store.formData[item.name]"
                    :payload="{resourceType:item.type}"
                    v-if="item.component === 'veui-uploader'"/>
                <veui-textarea
                    v-model="store.formData[item.name]"
                    v-if="item.component === 'veui-textarea'"/>
            </veui-field>
        </template>
        <template slot="operation">
            <veui-button ui="primary" type="submit" @click="setSubmitType('create')"
            >{{okText}}</veui-button>
            <veui-button ui="aux" type="submit" @click="setSubmitType('draft')"
            >保存草稿</veui-button>
            <veui-button ui="aux" @click="back">取消</veui-button>
        </template>
    </form-view>
</template>
<script>
import user from '@/common/system/config';
import uri from '@baidu/ve-ria/utils/uri';
import {getProxyParam} from '@/common/utils';
import FormView from '@baidu/ve-ria/views/FormView';
import CaseCreateModel from './CaseCreateModel';
import createView from '@baidu/ve-ria/views/createView';
import Uploader from '@/common/components/Uploader';
import {Steps, Field, Input, Textarea, Button} from 'veui';

export default createView(FormView, CaseCreateModel, {
    name: 'CaseCreateView',
    components: {
        'veui-steps': Steps,
        'veui-field': Field,
        'veui-input': Input,
        'veui-button': Button,
        'veui-textarea': Textarea,
        'veui-uploader': Uploader
    },
    created() {
        if (!this.isEdit && this.isMaterial) {
            this.store.getTemplateInfo(this.$route.query.templateId);
        }
    },
    computed: {
        isEdit() {
            return this.store.pageType === 'edit';
        },
        isMaterial() {
            return this.store.ARType === 'material';
        },
        okText() {
            if (this.isMaterial) {
                return '提交预览';
            }
            return this.isEdit ? '编辑Case' : '创建Case';
        },
        prefix() {
            return this.store.isAdmin ? '' : '/app';
        },
        uploadUrl() {
            const admin = this.store.isAdmin ? 'admin/' : '';
            return `/data/${admin}app/service/ar/media/upload`;
        }
    },
    methods: {
        setSubmitType(type) {
            this.store.submitType = type;
        },
        getAREditorUrl() {
            const param = getProxyParam(user.idKey);
            let url = param
                ? '' + uri.withQuery('/areditor/index.html', param, {querySeparator: '?'})
                : '/areditor/index.html';
            url = `${url}#/editor`;
            return url;
        },
        handleSubmit(result) {
            let redirectUrl;
            const url = this.getAREditorUrl();
            const {appId, projectId} = result;
            const serviceId = this.$route.params.serviceId;
            const type = this.store.isCopy ? 'copy' : this.store.pageType;
            // material 创建和详情页面
            if (this.isMaterial) {
                if (this.store.submitType === 'create') {
                    redirectUrl = `${this.prefix}/service/${serviceId}/ar/detail?from=${type}`;
                }
                else {
                    redirectUrl = !this.store.isAdmin
                        ? `${this.prefix}/service/list`
                        : `${this.prefix}/service/reviewing/list`;
                }
            }
            else {
                // case 创建和详情页面
                if (this.store.submitType === 'create') {
                    const finalUrl = `${url}?appid=${appId}&projectId=${projectId}&serviceId=${serviceId}`;
                    window.location = finalUrl;
                    return;
                }
                redirectUrl = !this.store.isAdmin
                    ? `${this.prefix}/service/list`
                    : `${this.prefix}/service/reviewing/list`;
            }
            this.$nextTick(() => {
                this.global.redirect({
                    url: redirectUrl,
                    type: 'push'
                });
            });
        }
    }
});
</script>

<style lang="less">
.case-create-view {
    .veui-input {
        width: 300px;
    }
    .veui-uploader {
        width: 300px;
    }
    .form-operation {
        margin-left: 0px;
    }
    .veui-steps-step {
        margin-right: 100px;

        &:after {
            width: 90px;
            right: -95px;
        }
    }
}
</style>
